<template>
  <div v-if="dataChildren.length > 0" class="layout-detail-form">
    <div v-if="conf && conf.bpmConfig && conf.bpmConfig.direction === 'row'" class="detail-row">
      <div class="detail-header">
        <div class="detail-index">#</div>
        <div v-for="(item, index) in dataChildren" :key="index" class="row-item" :class="{hideColumns: formEditList[item.vModel] && formEditList[item.vModel].operationType === 4}">
          <span v-if="item.bpmConfig && item.bpmConfig.required" class="required">*</span>{{ item.bpmConfig && item.bpmConfig.label || '' }}
        </div>
        <div v-if="!disabled" class="form-actions">操作</div>
      </div>
      <div v-for="(item, index) in list" :key="index" class="detail-body">
        <div class="detail-index">{{ index + 1 }}</div>
        <div v-for="(item2, index2) in dataChildren" :key="index2" class="row-item" :class="{hideColumns: formEditList[item2.vModel] && formEditList[item2.vModel].operationType === 4}">
          <keep-alive>
            <corporate-gifts-select v-if="item2.bpmConfig && item2.bpmConfig.optionType === 1 && item2.bpmConfig.statisticsTmpId === '1742922669609455628'" v-model="list[index][item2.vModel]" :fields="item2" :type="disabled ? 'readOnly' : ''" @change="(val) => setValue(val, list[index]['confList'][index2], index)" />
            <template v-else>
              <render
                v-if="conf.vModel"
                :form-data="formData"
                :text-show="true"
                :field="conf.vModel"
                :field-data="list[index]"
                :text-lable="list[index]['confList'][index2] && list[index]['confList'][index2].bpmConfig && list[index]['confList'][index2].bpmConfig.label || ''"
                :system-info="systemInfo"
                :is-edit-hisotry="isEditHisotry"
                :is-text="disabled || (formEditList[item2.vModel] && formEditList[item2.vModel].operationType === 3)"
                :conf="list[index]['confList'][index2]"
                :is-parse="true"
                @input="(val) => setValue(val, list[index]['confList'][index2], index)"
              />
            </template>
          </keep-alive>
        </div>
        <div v-if="!disabled" class="form-actions">
          <span class="copy" @click="copyItem(index)">复制</span>
          <span class="del" @click="deleteItem(index)">删除</span>
        </div>
      </div>
    </div>
    <div v-else class="detail-column">
      <div v-for="(item, index) in list" :key="index" class="detail-column-body">
        <div v-for="(item2, index2) in dataChildren" :key="index2" :class="{hideColumns: formEditList[item2.vModel] && formEditList[item2.vModel].operationType === 4}">
          <div class="detail-index"><span v-if="item2.bpmConfig && item2.bpmConfig.required" class="required">*</span>{{ item2.bpmConfig && item2.bpmConfig.label || '' }}</div>
          <div>
            <keep-alive>
              <corporate-gifts-select v-if="item2.bpmConfig && item2.bpmConfig.optionType === 1 && item2.bpmConfig.statisticsTmpId === '1742922669609455628'" v-model="list[index][item2.vModel]" :fields="item2" :type="disabled ? 'readOnly' : ''" @change="(val) => setValue(val, list[index]['confList'][index2], index)" />
              <template v-else>
                <render
                  v-if="conf.vModel"
                  :form-data="formData"
                  :text-show="true"
                  :field="conf.vModel"
                  :field-data="list[index]"
                  :text-lable="list[index]['confList'][index2] && list[index]['confList'][index2].bpmConfig && list[index]['confList'][index2].bpmConfig.label || ''"
                  :system-info="systemInfo"
                  :is-edit-hisotry="isEditHisotry"
                  :is-text="disabled || (formEditList[item2.vModel] && formEditList[item2.vModel].operationType === 3)"
                  :conf="list[index]['confList'][index2]"
                  :is-parse="true"
                  @input="(val) => setValue(val, list[index]['confList'][index2], index)"
                />
              </template>
            </keep-alive>
          </div>
        </div>
        <action-icon v-if="!disabled" :index="index" @delete="deleteItem" @copy="copyItem" />
      </div>
    </div>
    <div v-if="!disabled" class="drag-add">
      <svg-icon icon-class="form-add" @click.native="addDetails" />
      <span @click="addDetails">{{ conf.bpmConfig && conf.bpmConfig.actionName || '' }}</span>
    </div>

    <el-table
      v-if="conf && conf.bpmConfig && conf.bpmConfig.isCorporateGifts"
      :data="productList"
      style="width: 100%;margin-top:10px;"
    >
      <el-table-column
        prop="name"
        label="名称"
      />
      <el-table-column
        prop="image"
        label="图片"
      >
        <template slot-scope="scope">
          <img :src="scope.row.image" style="width:100px;">
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="purchaseCost"
        label="成本采购价（元/件）"
      /> -->
      <el-table-column
        prop="marketPrice"
        label="市场价（元/件）"
      />
    </el-table>
  </div>
</template>

<script>
import ActionIcon from './icon.vue'
import render from '@/views/form/components/render/render.js'
import cloneDeep from 'lodash/cloneDeep'
import corporateGiftsSelect from '@/components/corporateGiftsSelect'
import { debounce } from 'throttle-debounce'
import axios from 'axios'
export default {
  components: {
    render,
    ActionIcon,
    corporateGiftsSelect
  },
  props: {
    // 是否存在編輯記錄中
    isEditHisotry: {
      type: Boolean, // 禁止编辑
      default: false
    },
    disabled: {
      type: Boolean, // 禁止编辑
      default: false
    },
    value: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'row'
    },
    children: {
      type: Array,
      default: () => []
    },
    // 配置
    conf: {
      type: Object,
      default: () => {}
    },
    // 系统变量
    systemInfo: {
      type: Object,
      default: () => {}
    },
    formData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      list: [],
      productList: []
    }
  },
  computed: {
    formEditList() {
      return this.conf && this.conf.formEditList || {}
    },
    dataChildren() {
      // const formEditList = this.conf.formEditList
      return this.children.filter((item) => item.type !== 'empty')
    }
  },
  created() {},
  mounted() {
    if (this.value.length > 0) {
      this.list = cloneDeep(this.value)
      const list = this.list.map((item, index) => {
        item.confList = []
        this.dataChildren.forEach((item2, index2) => {
          if (item2.vModel) {
            item.confList[index2] = cloneDeep(item2)
            item.confList[index2].bpmConfig.defaultValue = item[item2.vModel]
          }
        })
        return item
      })
      this.list = list
    }
    // console.log('conf', this.conf)
    // console.log('list', this.list)
    // console.log('dataChildren',this.dataChildren)
    if (this.conf?.bpmConfig?.isCorporateGifts) {
      this.setInputNumberDisabled()
    }
  },
  methods: {
    setValue(value, item, index) {
      this.list[index][item.vModel] = value
      this.$set(item.bpmConfig, 'defaultValue', value)
      this.$emit('input', cloneDeep(this.list))
      if (this.conf?.bpmConfig?.isCorporateGifts) {
        this.calculateTotalPrice()
      }
    },
    // 添加明细
    addDetails() {
      const obj = {
        confList: []
      }
      this.dataChildren.forEach((item, index) => {
        if (item.vModel) {
          obj[item.vModel] = item.bpmConfig && item.bpmConfig.defaultValue
          obj.confList[index] = cloneDeep(item)
        }
      })
      this.list.push(obj)
      this.$emit('input', cloneDeep(this.list))
    },
    copyItem(index) {
      this.list.push(cloneDeep(this.list[index]))
      this.$emit('input', cloneDeep(this.list))
      if (this.conf?.bpmConfig?.isCorporateGifts) {
        this.calculateTotalPrice()
      }
    },
    deleteItem(index) {
      this.list.splice(index, 1)
      this.$emit('input', cloneDeep(this.list))
      if (this.conf?.bpmConfig?.isCorporateGifts) {
        this.calculateTotalPrice()
      }
    },
    // 业财1.1 计算总价逻辑
    calculateTotalPrice: debounce(500, function() {
      let selectVModel = ''
      let inputNumberVModel = ''

      // 先判断是否存在集团礼品的下拉框和计数器
      for (let i = 0; i < this.dataChildren.length; i++) {
        if (this.dataChildren[i]?.bpmConfig?.statisticsTmpId === '1742922669609455628' && this.dataChildren[i]?.bpmConfig?.optionType === 1) {
          selectVModel = this.dataChildren[i].vModel
        }
        if (this.dataChildren[i]?.compType === 3) {
          inputNumberVModel = this.dataChildren[i].vModel
        }
      }

      if (selectVModel && inputNumberVModel) {
        this.calculateTotalPriceInit(selectVModel, inputNumberVModel)
      }
    }),
    calculateTotalPriceInit(selectVModel, inputNumberVModel) {
      const ids = []
      for (let i = 0; i < this.list.length; i++) {
        ids.push(this.list[i][selectVModel])
      }
      // 商品要根据ids去展示，没有ids就没有商品
      if (ids.length === 0) {
        this.productList = []
        this.setTotalPrice(0)
        return
      }
      axios({
        method: 'post',
        url: process.env.VUE_APP_YC + '/feign/souvenir/queryByParam',
        data: {
          keyword: '',
          ids
        }
      }).then((e) => {
        const res = e.data
        if (res && res.code === '200' && res.data instanceof Array) {
          const commodity = res.data
          let totalPrice = 0
          this.productList = commodity
          // 计算总价
          for (let i = 0; i < this.list.length; i++) {
            const id = this.list[i][selectVModel]
            const num = this.list[i][inputNumberVModel] || 0
            const oneItem = commodity.find(item => item.id === id)

            if (oneItem) {
              totalPrice = totalPrice + (parseFloat(oneItem.marketPrice) * num)
            }
          }
          this.setTotalPrice(totalPrice)
        } else {
          this.productList = []
        }
      }).catch(() => {
        this.productList = []
      })
    },
    setTotalPrice(totalPrice) {
      const thisVModel = this.conf?.bpmConfig?.inputNumberVModel
      this.formData[thisVModel] = totalPrice
      const dom = document.querySelector(`.vModel_${thisVModel} input`)
      if (dom) {
        dom.value = totalPrice
      }
    },
    setInputNumberDisabled() {
      const thisVModel = this.conf?.bpmConfig?.inputNumberVModel
      if (thisVModel) {
        const dom = document.querySelector(`.vModel_${thisVModel}`)
        if (dom) {
          dom.classList.add('inputNumberDisabled')
        }
      }
    }

  }
}
</script>

<style lang="scss" scoped>
  .layout-detail-form {
    margin-bottom: 10px;
    .required {
      content: '*';
      color: #ff4949;
      margin-right: 4px;
    }
    .hideColumns {
      display: none;
    }
    .detail-row {
      border-top: 1px solid #E5E6EB;
      border-left: 1px solid #E5E6EB;
      overflow: hidden;
      overflow-x: auto;
      border-radius: 4px;
      .detail-header, .detail-body {
        color: #86909C;
        display: flex;
        >div {
          font-size: 12px;
          background: #F4F7FF;
          min-height: 28px;
          padding: 10px 16px;
          box-shadow: inset 0px -1px 0px 0px #E5E6EB, inset -1px 0px 0px 0px #E5E6EB;
        }
        >div:nth-of-type(1) {
          width: 56px;
        }
        >div:nth-of-type(n + 1) {
          flex: 1;
        }
        .form-actions {
          max-width: 100px;
          min-width: 100px;
          .copy {
            color: #2C51EF;
            cursor: pointer;
            margin-right: 10px;
          }
          .del {
            color: #ff4949;
            cursor: pointer;
          }
        }
      }
        .detail-body {
          color: #1D2129;
          >div {
            background: #fff;
        }
      }
      .detail-index {
        width: 60px;
        max-width: 60px;
        min-width: 60px;
      }
      .row-item {
        min-width: 200px;
        overflow-x: auto;
      }
    }
    .detail-column {
      border-radius: 4px;
      border-top: 0px;
      >div {
        background: #FFFFFF;
        color: #1D2129;
      }
      .detail-column-body {
        border: 1px solid #E5E6EB;
        border-radius: 4px;
        margin-bottom: 16px;
        position: relative;
      }
      .detail-index {
        padding-left: 21px;
        background: #F7F8FA;
        color: #86909C;
        line-height: 36px;
        &+div {
          background: #FFFFFF;
          color: #1D2129;
          padding-left: 21px;
          padding: 10px 21px 10px 21px;
        }
      }
    }
    .drag-add {
        text-align: center;
        padding: 10px 0px 10px 0px;
        svg {
          margin-right: 8px;
          width: 16px;
          height: 16px;
          cursor: pointer;
        }
        span {
          color: #2C51EF;
          font-weight: 500;
          font-size: 16px;
          cursor: pointer;
        }
      }
      /deep/.el-input__inner {
          border-color: #DCDFE6 !important;
      }
      /deep/.el-textarea__inner {
        border-color: #DCDFE6 !important;
      }
  }
</style>
